// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"213":"3968d444","229":"05393cb3","369":"696080e7","423":"40b3670b","426":"938630a2","672":"fcdb5342","705":"77a4ffa6"}[chunkId] + ".js";
};